export function formatDate(dateString?: string | Date | null): string {
  if (!dateString) return "-";
  try {
    const date = typeof dateString === "string" ? new Date(dateString) : dateString;
    if (isNaN(date.getTime())) return "-";
    return new Intl.DateTimeFormat("pt-BR", {
      dateStyle: "short",
      timeStyle: "medium",
    }).format(date);
  } catch {
    return String(dateString);
  }
}

export function formatRelativeTime(dateString?: string | null): string {
  if (!dateString) return "-";
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffSec = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffSec < 60) return `${diffSec}s atrás`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m atrás`;
    if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h atrás`;
    return `${Math.floor(diffSec / 86400)}d atrás`;
  } catch {
    return "-";
  }
}
